import { ASSOCIATION } from 'customer-data-objects/field/FieldTypes';
import { parseAssociationFieldName, getCachedAssociationValuesForField } from './utils';
import AssociationAndLabelInputContainer from '../input/association/AssociationAndLabelInputContainer';
import { normalizeAssociationValueAsArray } from '../utils/normalizeValue';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeAssociationInput = ({
  fieldName,
  associationDefinitionsMap,
  cachedAssociationValues,
  getAssociationFormValue,
  handleAssociationChange,
  handleAssociationLabelChange,
  isRequired,
  parentFieldName,
  objectTypeId,
  parent
}) => {
  var _associationFormValue;
  const associationDefinitionsArray = Object.values(associationDefinitionsMap);
  const parsedFieldName = parseAssociationFieldName(fieldName);
  if (!parsedFieldName) {
    return undefined;
  }
  const {
    defaultAssociationIdentifier,
    associationLabelIdentifier,
    isLabelRequired
  } = parsedFieldName;
  const defaultAssociationDefinition = associationDefinitionsMap[defaultAssociationIdentifier];
  const associationLabelDefinition = associationDefinitionsMap[associationLabelIdentifier] || defaultAssociationDefinition;
  if (!(defaultAssociationDefinition !== null && defaultAssociationDefinition !== void 0 && defaultAssociationDefinition.isDefault) || !associationLabelDefinition) {
    return undefined;
  }
  // Missing associationLabelIdentifier represents the "No Label" case for which we hide the label input
  // - Pre-CHIRP migration, we use an empty string
  // - Post-CHIRP migration, associationLabelIdentifier will be optional and not returned for the "No Label" case
  const hideLabelInput = associationLabelIdentifier === '' || !associationLabelIdentifier;
  const associationFormValue = getAssociationFormValue(fieldName);
  const associationValue = (associationFormValue === null || associationFormValue === void 0 ? void 0 : associationFormValue.objectIds) || null;
  const hasSpecificLabel = defaultAssociationIdentifier !== associationLabelIdentifier;
  const labelValue = (_associationFormValue = associationFormValue === null || associationFormValue === void 0 ? void 0 : associationFormValue.labelIdentifier) !== null && _associationFormValue !== void 0 ? _associationFormValue :
  // technically it shouldn't be possible for a LABEL_REQUIRED field to have a specific label ID,
  // but this prevents a UI error if somehow the label is required and the label ID equals the default association ID
  isLabelRequired && hasSpecificLabel ? associationLabelIdentifier : null;
  const allowsMoreThanOneAssociation = associationLabelDefinition.maxToObjectIds > 1 && defaultAssociationDefinition.maxToObjectIds > 1;
  const id = `${parentFieldName}/${fieldName}`;
  return {
    association: {
      defaultAssociationDefinition,
      associationLabelDefinition
    },
    fieldName,
    fieldType: ASSOCIATION,
    isRequired,
    isLabelRequired,
    parent,
    dependents: null,
    validation: null,
    render: () => /*#__PURE__*/_jsx(AssociationAndLabelInputContainer, {
      id: id,
      associationDefinition: defaultAssociationDefinition,
      associationLabelDefinition: associationLabelDefinition,
      associationDefinitions: associationDefinitionsArray,
      associationValue: associationValue,
      cachedAssociationValuesForField: getCachedAssociationValuesForField({
        fieldName,
        cachedAssociationValues
      }),
      labelValue: labelValue,
      onAssociationChange: event => handleAssociationChange(fieldName, normalizeAssociationValueAsArray(event.target.value)),
      isMulti: allowsMoreThanOneAssociation,
      onLabelChange: event => {
        handleAssociationLabelChange(fieldName, event.target.value || null);
      },
      required: isRequired,
      objectTypeId: objectTypeId,
      isLabelRequired: isLabelRequired,
      hideLabelInput: hideLabelInput
    }, id)
  };
};